
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRank1 as ObiRank1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-rank-1.js';
 
 
 

 
 export const ObiRank1 = createComponent({
   react: React,
   tagName: 'obi-rank-1',
   elementClass: ObiRank1Element,
   events: {
     
   }
  });
 
 